export default "__VITE_ASSET__C4dQxibn__"